var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'v-input',
    'v-input--hide-details',
    'v-input--is-label-active',
    'theme--light',
    'v-text-field',
    'v-text-field--enclosed',
    'v-text-field--outlined',
    'v-text-field--placeholder',
    {'primary--text': _vm.focused}
  ]},[_c('div',{staticClass:"v-input__control"},[_c('div',{staticClass:"v-text-field__slot"},[_c('label',{class:[
          'v-label',
          'v-label--active',
          'theme--light',
          {'primary--text': _vm.focused}
        ],attrs:{"for":"files-participants"}},[_vm._t("default")],2),_vm._t("input")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }